import { m } from '#lib/paraglide/messages.js'
import { formatFinality, formatTime } from '#lib/utils/formatters.js'
import type { timeChartSchema } from '#lib/utils/schema.js'

export type TimeChartMetric = ReturnType<typeof timeChartSchema.parse>['metric']

type TimeChartMetricConfig = {
	name: () => string
	format: (value: number) => string
}

export const TIME_CHART_METRIC_CONFIG: Record<TimeChartMetric, TimeChartMetricConfig> = {
	ttf: {
		name: m.metric_ttf_name,
		format: value => formatFinality(value, true),
	},
	block_time: {
		name: m.metric_blocktime_name,
		format: value => formatTime(value, true),
	},
}
